import { useDataValue, useDataIsSubmitting } from 'Simple/Data.js'

export function useIsDisabled(props) {
  let isSubmitting = useDataIsSubmitting({
    context: 'steps',
    viewPath: props.viewPath,
  })

  let current_index = useDataValue({
    context: 'steps',
    path: 'current_index',
    viewPath: props.viewPath,
  })

  let steps = useDataValue({
    context: 'steps',
    path: 'steps',
    viewPath: props.viewPath,
  })

  return (
    isSubmitting ||
    (steps[current_index].required &&
      (steps[current_index].value === null ||
        steps[current_index].value === undefined ||
        steps[current_index].value === ''))
  )
}
